/*eslint-disable */
const $ = window.jQuery = require('jquery'); 
export default {
  name: 'used-models-history-list',
  components: {
  },
  props: [],
  data () {
    return {
      modelsHistoryData:null,
      modelsHistoryDataResults:[]
    }
  },
  computed: {
  },
  mounted () {
    this.getModelsHistoryListFunc();
  },
  methods: {
    getModelsHistoryListFunc() {
      this.$store.dispatch('getHistoryModelsForAiDashFun').then((res) => {
        this.modelsHistoryData = res.data.data
        this.modelsHistoryDataResults = this.modelsHistoryData.results 
      })
    },
  },
  watch:{
  }
}